export type TermsBlock =
  | { type: "paragraph"; text: string }
  | { type: "subheading"; text: string }
  | { type: "list"; items: string[] }
  | {
      type: "linkParagraph";
      before: string;
      href: string;
      linkText: string;
      after: string;
    };

export type TermsSection = {
  id: string;
  title: string;
  navTitle: string;
  blocks: TermsBlock[];
};

export const termsOfServiceIntro =
  "We will provide the services to you, which are subject to the conditions stated below in this document. Every time you visit this website, use its services, or make a purchase, you accept the following conditions. Therefore, we urge you to read them carefully.";

export const termsOfServiceSections: TermsSection[] = [
  {
    id: "conditions-of-use",
    title: "Conditions of Use",
    navTitle: "Conditions of Use",
    blocks: [
      {
        type: "paragraph",
        text: "We will provide the services to you, which are subject to the conditions stated below in this document. Every time you visit this website, use its services, or make a purchase, you accept the following conditions. Therefore, we urge you to read them carefully.",
      },
    ],
  },
  {
    id: "privacy-policy",
    title: "Privacy Policy",
    navTitle: "Privacy Policy",
    blocks: [
      {
        type: "linkParagraph",
        before:
          "Before you continue using our website we advise you to read our privacy policy ",
        href: "/privacy-policy",
        linkText: "https://www.aaneel.com/application-privacy-policy",
        after:
          " regarding our user data collection. It will help you better understand our practices.",
      },
    ],
  },
  {
    id: "copyright",
    title: "Copyright",
    navTitle: "Copyright",
    blocks: [
      {
        type: "paragraph",
        text: "Content published on this website (digital downloads, images, texts, graphics, logos) is the property of AaNeel Infotech LLC. And /or its content creators and protected by international copyright laws. The entire compilation of the content found on this website is the exclusive property of AaNeel Infotech LLC., with copyright authorship for this compilation by AaNeel Infotech LLC.",
      },
    ],
  },
  {
    id: "communication",
    title: "Communication",
    navTitle: "Communication",
    blocks: [
      {
        type: "paragraph",
        text: "The entire communication with us is electronic. Every time you send us an email or visit our website, you are going to be communicating with us. You hereby consent to receive communications from us. If you subscribe to the news on our website, you are going to receive regular emails from us. We will continue to communicate with you by posting news and notices on our website and by sending you emails. You also agree that all notices, disclosures, agreements, and other communications we provide to you electronically meet the legal requirements that such communications be in writing.",
      },
    ],
  },
  {
    id: "applicable-law",
    title: "Applicable Law",
    navTitle: "Applicable Law",
    blocks: [
      {
        type: "paragraph",
        text: "By visiting this website, you agree that the laws of the state of Florida without regard to principles of conflict laws, will govern these terms of service, or any dispute of any sort that might come between AaNeel Infotech LLC. and you, or its business partners and associates.",
      },
    ],
  },
  {
    id: "disputes",
    title: "Disputes",
    navTitle: "Disputes",
    blocks: [
      {
        type: "paragraph",
        text: "Any dispute related in any way to your visit to this website or to products you purchase from us shall be arbitrated by state or federal court and your consent to exclusive jurisdiction and venue of such courts.",
      },
    ],
  },
  {
    id: "fhir-api",
    title: "FHIR API",
    navTitle: "FHIR API",
    blocks: [
      {
        type: "paragraph",
        text: 'AaNeelConnect provides FHIR-based application programming interface (“API”) technology and interoperability services to Medicare Advantage and other health plan clients. Our API services are designed to support secure electronic access, exchange, and use of health information in accordance with applicable technical standards, contractual requirements, and interoperability requirements.',
      },
      {
        type: "subheading",
        text: "Authorized Use",
      },
      {
        type: "paragraph",
        text: "Access to AaNeelConnect FHIR APIs is permitted only through authorized authentication and authorization mechanisms and for lawful purposes. Users, applications, and developers accessing our APIs may not:",
      },
      {
        type: "list",
        items: [
          "Attempt to access information beyond the scope authorized by the applicable individual, Health Plan, or API authorization;",
          "Circumvent or interfere with authentication, authorization, security, or access controls;",
          "Misuse credentials, access tokens, client identifiers, or other security mechanisms;",
          "Introduce malicious code or interfere with the security, integrity, or availability of the API or associated systems; or",
          "Use information obtained through the API in violation of applicable law or applicable authorization.",
        ],
      },
      {
        type: "subheading",
        text: "Third-Party Applications",
      },
      {
        type: "paragraph",
        text: "Our FHIR API services may enable a Health Plan member to authorize disclosure of health information to an independently operated third-party application.",
      },
      {
        type: "paragraph",
        text: "AaNeelConnect does not own, operate, endorse, or control independent third-party applications unless expressly stated otherwise. Users should review the privacy policy and terms of any third-party application before authorizing access to health information.",
      },
      {
        type: "paragraph",
        text: "Once an authorized transmission to an independent third-party application is completed, the third party's terms and privacy practices govern its subsequent handling of the information, subject to applicable law.",
      },
      {
        type: "subheading",
        text: "API Security and Availability",
      },
      {
        type: "paragraph",
        text: "AaNeelConnect may implement reasonable security controls necessary to protect its APIs, systems, users, and information from unauthorized access, misuse, or security threats. API access may be restricted or suspended when reasonably necessary to address a security threat, compromised credentials, unauthorized activity, or other circumstances permitted by applicable law.",
      },
      {
        type: "paragraph",
        text: "Nothing in these Terms is intended to prohibit or unreasonably interfere with access, exchange, or use of health information required under applicable interoperability requirements.",
      },
      {
        type: "subheading",
        text: "Health Plan Responsibilities",
      },
      {
        type: "paragraph",
        text: "AaNeelConnect provides technology and services supporting Health Plan interoperability activities. Each Health Plan remains responsible for the regulatory and operational obligations applicable to it as a regulated health plan, except where responsibilities have been expressly delegated to AaNeel.",
      },
    ],
  },
  {
    id: "comments-reviews-emails",
    title: "Comments, Reviews, and Emails",
    navTitle: "Comments & Reviews",
    blocks: [
      {
        type: "paragraph",
        text: "Visitors may post content if it is not obscene, illegal, defamatory, threatening, infringing of intellectual property rights, invasive of privacy or injurious in any other way to third parties. Content must be free of software viruses, political campaign, and commercial solicitation. We reserve all rights (but not the obligation) to remove and/or edit such content. When you post your content, you grant AaNeel Infotech LLC. non-exclusive, royalty-free, and irrevocable right to use, reproduce, publish, and modify such content throughout the world in any media.",
      },
    ],
  },
  {
    id: "license-site-access",
    title: "License and Site Access",
    navTitle: "License & Access",
    blocks: [
      {
        type: "paragraph",
        text: "We grant you a limited license to access and make personal use of this website. You are not allowed to download or modify it. This may be done only with written consent from us.",
      },
    ],
  },
  {
    id: "user-account",
    title: "User Account",
    navTitle: "User Account",
    blocks: [
      {
        type: "paragraph",
        text: "If you are an owner of an account on this website, you are solely responsible for maintaining the confidentiality of your private user details (username and password). You are responsible for all activities that occur under your account or password. In compliance with applicable privacy and security requirements and controls, AaNeel reserves the right to monitor systems, accounts, product use, and activity. Additionally, AaNeel reserves all rights to terminate accounts, edit or remove content, and cancel orders in their sole discretion.",
      },
    ],
  },
];
